// extracted by mini-css-extract-plugin
export default {"bellWrapper":"Dashboard_bellWrapper__0GTxB","redDot":"Dashboard_redDot__eTD4y"};